/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-collapsible::before, .ux-collapsible::after {
  content: " ";
  display: table;
}
.ux-collapsible::after {
  clear: both;
}
.ux-collapsible-content__container {
  overflow: hidden;
  transition: height 250ms ease;
}
.ux-collapsible-content__inner {
  overflow: visible;
  transition: opacity 250ms ease;
}
.ux-collapsible-content__inner::before, .ux-collapsible-content__inner::after {
  content: " ";
  display: table;
}
.ux-collapsible-content__inner::after {
  clear: both;
}
.ux-collapsible-button {
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  align-items: center;
  appearance: none;
  background: transparent none;
  border: 0 none transparent;
  cursor: pointer;
  display: inline-flex;
  flex-flow: row nowrap;
  font-size: 16px;
  justify-content: center;
  margin: auto;
  outline: none;
}
.ux-collapsible-button__container {
  padding: 15px 0;
}
.ux-collapsible-button__spacer {
  flex: 0 0 10px;
}
.ux-collapsible-button__label, .ux-collapsible-button__icon {
  display: inline-block;
  white-space: nowrap;
}
.ux-collapsible-button__container--centered {
  text-align: center;
}
.ux-collapsible-arrow {
  display: block;
  height: auto;
  transform: none;
  transition: transform 250ms ease;
  transition-delay: 250ms;
  width: 16px;
}
.ux-collapsible--collapsed .ux-collapsible-content__container {
  height: 0;
}
.ux-collapsible--collapsed .ux-collapsible-content__inner {
  opacity: 0;
}
.ux-collapsible--expanded .ux-collapsible-content__container {
  height: auto;
  overflow: visible;
}
.ux-collapsible--expanded .ux-collapsible-content__inner {
  opacity: 1;
  transition-duration: 500ms;
}
.ux-collapsible--expanded .ux-collapsible-arrow {
  transform: rotate(180deg);
}
.ux-collapsible--direction-bottom h2 {
  margin-top: 0;
}
.ux-collapsible--accordion .ux-collapsible-button__container {
  align-items: flex-start;
  background-color: #eff0f4;
  border-bottom: 0;
  padding: 15px 30px;
}
.ux-collapsible--accordion .ux-collapsible-button {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
}
.ux-collapsible--accordion .ux-collapsible-button__label {
  font-size: 13px;
  font-weight: 800;
}